// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "0356e401a877a7e59455" + ".bundle.js";
};